import { AxiosError } from 'axios';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { RootState } from '../root-reducer';
import { addNotification, removeNotification } from './actions';
import { NotificationMessage, NotificationType } from './types';

const generateId = () => Math.random().toString(36).substring(2, 15);

export const clickNotificationButton =
  (id: string, callback: () => void): ThunkAction<void, RootState, null, Action> =>
  async (dispatch, getState) => {
    const message = getState().notifications.find((item) => item.id === id);
    if (!message) {
      return;
    }
    if (callback) {
      callback();
    }
    dispatch(removeNotification(message.id));
  };

export const pushNotification =
  (
    type: NotificationType,
    title: string,
    seconds = 3,
    buttonTitle = null,
    onClickButton = null,
    onRemove = null,
  ): ThunkAction<void, Pick<RootState, 'notifications'>, null, Action> =>
  async (dispatch, getState) => {
    const id = generateId();
    const newMessage: NotificationMessage = {
      id,
      type,
      title,
      buttonTitle,
      onClickButton: () => dispatch(clickNotificationButton(id, onClickButton)),
      onRemove,
    };
    dispatch(addNotification(newMessage));
    await new Promise((resolve) => setTimeout(resolve, seconds * 1000));
    const message = getState().notifications.find((item) => item.id === newMessage.id);
    if (message) {
      dispatch(removeNotification(message.id));
      if (message.onRemove) {
        message.onRemove();
      }
    }
  };

// TODO handle error types: 500 / on internet connection / etc
export const pushNotificationApiError = (error: AxiosError | Error | any) => {
  if (error.response) {
    const {
      response: { statusText, data },
    }: AxiosError = error;
    const message = data && data.message ? data.message : statusText;
    return pushNotification(NotificationType.ERROR, message);
  }

  return pushNotification(NotificationType.ERROR, error.message);
};
